import React from 'react';
import {COLORS, SIZES, Typography} from '@fupa/fupa-uikit';
import styled from 'styled-components';

const Link = styled.a`
  display: inline-flex;
  color: ${COLORS.black};

  &:focus,
  &:hover {
    color: ${COLORS.black};
  }

  &:visited,
  &:link,
  &:active {
    color: ${COLORS.black};
  }
`;

const StyledTypography = styled(Typography)`
  &&& {
    display: inline-flex;
    align-items: center;
    @media only screen and (min-width: 492px) {
      font-size: ${SIZES['16']};
    }
  }
`;

const SocialLink = ({link, label}) => {
  return (
    <Link href={link} target='_blank'>
      <StyledTypography variant='body1'>{label}</StyledTypography>
    </Link>
  );
};

export {SocialLink};
